/**
 * @fileoverview V2 Step definitions — single source of truth for the wizard steps.
 */
import type { LucideIcon } from 'lucide-react';
import {
  ClipboardList,
  FileText,
  Heart,
  Scale,
  Shield,
  Sparkles,
  Upload,
  User,
  UserPlus,
  Users,
} from 'lucide-react';

export interface StepDef {
  /** Unique identifier used in URL ?step= param */
  id: string;
  /** Short sidebar label */
  label: string;
  /** Lucide icon component */
  icon: LucideIcon;
  /** 'creation' steps happen before matter exists */
  phase: 'creation' | 'ingestion';
}

/**
 * Ordered step list.  Index = step number.
 * Only "basics" is registered for now — others will be added as built.
 */
export const STEPS: StepDef[] = [
  { id: 'basics', label: 'Basics', icon: ClipboardList, phase: 'creation' },
  { id: 'case_info', label: 'Case Info', icon: FileText, phase: 'ingestion' },
  { id: 'client_info', label: 'Client', icon: User, phase: 'ingestion' },
  { id: 'companions', label: 'Companions', icon: Users, phase: 'ingestion' },
  { id: 'liability', label: 'Police', icon: Scale, phase: 'ingestion' },
  { id: 'treatment', label: 'Treatment', icon: Heart, phase: 'ingestion' },
  { id: 'coverage', label: 'Coverage', icon: Shield, phase: 'ingestion' },
  { id: 'documents', label: 'Documents', icon: Upload, phase: 'ingestion' },
  { id: 'notes', label: 'Notes', icon: Sparkles, phase: 'ingestion' },
  { id: 'review', label: 'Review', icon: UserPlus, phase: 'ingestion' },
];

/** Convenience: number of creation-phase steps */
export const CREATION_STEP_COUNT = STEPS.filter(
  (s) => s.phase === 'creation',
).length;
